var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGreenUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 7,
    fill: "url(#paint0_linear_1501_3815)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7535 24.16V22.3467C23.7535 21.3848 23.3714 20.4624 22.6913 19.7822C22.0111 19.1021 21.0887 18.72 20.1268 18.72H12.8735C11.9116 18.72 10.9892 19.1021 10.3091 19.7822C9.62892 20.4624 9.24683 21.3848 9.24683 22.3467V24.16",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 15.0934C18.5032 15.0934 20.1269 13.4696 20.1269 11.4667C20.1269 9.46373 18.5032 7.84002 16.5002 7.84002C14.4972 7.84002 12.8735 9.46373 12.8735 11.4667C12.8735 13.4696 14.4972 15.0934 16.5002 15.0934Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1501_3815",
    x1: 34.7456,
    y1: -10.88,
    x2: -3.75432,
    y2: -7.24609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87DF41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AB4F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreenUser);
export default __webpack_public_path__ + "static/media/icon-green-user.81857230fabb2438b360ae4bff91f008.svg";
export { ForwardRef as ReactComponent };